import merge from 'lodash/merge';
import RestEntityAPI from './restEntityAPI';
import config from '../../config';
import logger from '../logger';
import fetch, { toQueryString } from '../fetch';

const options = {
  entityName: 'notifications',
  endpoint: `${config.apiUrl}/v1/notifications`,
};

const NotificationsAPI = () => {
  const parentAPI = RestEntityAPI(options);

  const getUnseenNotificationsCount = async (query = {}) => {
    try {
      return await fetch(`${options.endpoint}/site/count-unseen${toQueryString(query)}`, {
        method: 'GET',
      });
    } catch (error) {
      logger.logDebug('Failed to fetch notifications count', error);
      throw error;
    }
  };

  const getEmployerNotifications = async (query = {}) => {
    try {
      return await fetch(`${options.endpoint}/site${toQueryString(query)}`, {
        method: 'GET',
      });
    } catch (error) {
      logger.logDebug('Failed to retrieve employer notifications for this user', error);
      throw error;
    }
  };

  const markNotificationAsSeen = async (data) => {
    try {
      return await fetch(`${options.endpoint}/site/seen-at`, {
        method: 'PATCH',
        body: data,
      });
    } catch (error) {
      logger.logDebug('Failed to mark notifications as seen', error);
      throw error;
    }
  };

  return merge({}, { ...parentAPI }, {
    getUnseenNotificationsCount,
    getEmployerNotifications,
    markNotificationAsSeen,
  });
};

export default NotificationsAPI;
